export enum LimitSortMethod {
  Orders = 'Orders',
  Type = 'Type',
  TriggerPrice = 'Trigger Price',
  MarkPrice = 'Mark Price',
  Size = 'Size',
  Bonus = 'Bonus',
  Action = 'Action',
}
